import React from 'react';
import Button from './smallerComponent/Button';

export default function Third(){
    return(
        <div className="third">
            <h1>Boost your links today</h1>
            <Button className="getStarted" value="Get Started" type="submit"/>
        </div>
    )
}